import { render, staticRenderFns } from "./TheBestTijuanaComponent.vue?vue&type=template&id=ee6192fc&scoped=true"
import script from "./TheBestTijuanaComponent.vue?vue&type=script&lang=js"
export * from "./TheBestTijuanaComponent.vue?vue&type=script&lang=js"
import style0 from "./TheBestTijuanaComponent.vue?vue&type=style&index=0&id=ee6192fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6192fc",
  null
  
)

export default component.exports